import {FC} from 'react';
import {useTranslation} from 'react-i18next';
import * as Yup from 'yup';
import {List} from '@tickchak/react-share/app';
import {TShow} from '../../../../../hooks/useShow';
import TimeInput from '../../../../../component/input/dateInput/TimeInput';
import FormContext from '../../../../components/formContext/FormContext';
import BackArrow from '../../../../../assets/icons/BackArrow';
import {createSlot} from '../../../../../redux/timetable/timetableActions';
import {getDateFormat, getNow, getStartOfDay, getTimeArray, tsToDate} from '../../../../../library/dates';
import * as css from './popupCard.css';

interface Props {
    show: TShow;
    dayTimestamp: number;
    onAdd: (tsid: number) => void;
}

const TimeField = TimeInput as unknown as FC<{
    name: string;
    text: string;
    isTimestamp?: boolean;
    isFixed?: boolean;
    timePickerProps?: object;
}>;

const AddSlotPopup: FC<Props> = ({show, dayTimestamp, onAdd}) => {
    const {t} = useTranslation('timetable');
    if(!show.isOpen) return null;

    const dayTs = dayTimestamp || getStartOfDay(getNow());
    const close = () => show.close();

    const submit = async (_: unknown, {time}: {time: number}) => {
        if(!time) return;
        const [h, m] = getTimeArray(time);
        const slot = await createSlot(dayTs + h * 3600 + m * 60);
        if(slot) onAdd(slot.tsid);
        close();
    };

    return (
        <FormContext
            initialValues={{time: null}}
            validationSchema={Yup.object({time: Yup.number().required(t('global:invalidTime')).typeError(t('global:invalidTime'))})}
            onSubmit={submit}
        >
            {/* eslint-disable-next-line react-redux/no-unused-prop-types */}
            {({submitForm}: {submitForm: () => void}) => (
                <List show={show} data-cy="addSlotPop" position={{width: '375px', height: '432px'}} ariaLabel={t('addSlotTitle')}>
                    <List.Header fixed title={t('addSlotTitle')} onBack={close} backIcon={<BackArrow />} />
                    <List.Items>
                        <css.slotForm>
                            <css.dateBanner>
                                <css.dateBannerIcon />
                                <span>
                                    {t('addSlotDateLabel')} <b>{tsToDate(dayTs, 'he', null, 'dddd') || ''} -</b>{' '}
                                    <b>{getDateFormat(dayTs, 'DD.MM.YY')}</b>
                                </span>
                            </css.dateBanner>
                            <css.slotInputBox>
                                <TimeField name="time" text={t('addSlotInputLabel')} isTimestamp isFixed timePickerProps={{autoFocus: true}} />
                            </css.slotInputBox>
                        </css.slotForm>
                    </List.Items>
                    <List.Footer fixed>
                        <List.Footer.Close text={t('cancel')} size="category" onClick={close} />
                        <List.Footer.Button text={t('add')} variant="brand" size="category" onClick={submitForm} />
                    </List.Footer>
                </List>
            )}
        </FormContext>
    );
};

export default AddSlotPopup;
